import md5 from 'js-md5'

/**
 * 给api进行md5签名
 * @param {Object} apikey
 * @param {Object} appversion
 * @param {Object} platform
 * @param {Object} ts
 * @param {Object} secret
 */
export function apiSign (apikey, appversion, platform, ts, secret) {
  const str = 'apikey=' + apikey +
		'&appversion=' + appversion +
		'&platform=' + platform +
		'&ts=' + ts +
		'&secret=' + secret

  return md5(str)
}

/**
 * 微信支付获取prepay_id之后发起正式支付时的支付请求
 * @param {Object} appId
 * @param {Object} nonceStr
 * @param {Object} pkg
 * @param {Object} signType
 * @param {Object} timeStamp
 * @param {Object} key
 */
export function wxmpPaySign (appId, nonceStr, pkg, signType, timeStamp, key) {
  const str = 'appId=' + appId +
		'&nonceStr=' + nonceStr +
		'&package=' + pkg +
		'&signType=' + signType +
		'&timeStamp=' + timeStamp +
		'&key=' + key

  console.log('paySignStr: ', str)

  return md5(str).toUpperCase()
}
